@if (financeFrom) {
  <span
    class="p2 flex flex-justify-between-s">
    <div class="p-r-1">
      <span class="col-11 p-r-1"
      translate>Finance your purchase from</span>
      <span class="col-1">&#163;{{financeFrom}}&nbsp;p/m</span>
    </div>
    <button [iCmsModalOpen]="'v12RetailFinanceDetailsModal'"
      [iCmsModalOpenData]="{ amount: amount }">
      <i class="icon-information col-11"
        aria-hidden="true"
      [style.font-size.rem]="1.4"></i>
    </button>
  </span>
}
